import { defineMosaicComponent } from "@/components/Mosaic/defineMosaicComponent";

import type CaseFindingLayoutBase from "@/components/CaseFindingLayout.Base.vue";

export default defineMosaicComponent<typeof CaseFindingLayoutBase>("components/CaseFindingLayout");
